module.exports = __webpack_public_path__ + "img/Group 6.591cb6ee.svg";